const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolves a stored media URL for use in <img src>, <video src>, download links, etc.
 * - Absolute URLs (http:// or https://) are returned unchanged (legacy records)
 * - Relative paths starting with "/api/files/" are prefixed with REACT_APP_BACKEND_URL
 *   so the frontend always talks to the currently-configured backend, regardless of
 *   whether the record was created in preview or production.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

/**
 * Turns a stored file URL into a "force-download" URL.
 * Works for anything served by GET /api/files/{path} — appends ?download=true.
 * Handles both relative and absolute URLs.
 */
export function toDownloadUrl(url, filename) {
  if (!url || typeof url !== "string") return url;
  const resolved = resolveMediaUrl(url);
  if (!/\/api\/files\//.test(resolved)) return resolved;
  const sep = resolved.includes("?") ? "&" : "?";
  const nameParam = filename ? `&name=${encodeURIComponent(filename)}` : "";
  return `${resolved}${sep}download=true${nameParam}`;
}
